import { render } from "./TwoBlocksLayout.vue?vue&type=template&id=af6eb000&bindings={\"navigate\":\"props\",\"sottoTitolo\":\"props\",\"descrizione\":\"props\",\"claim\":\"props\",\"note\":\"props\",\"iconList\":\"props\",\"cta\":\"props\",\"images\":\"props\",\"image\":\"props\",\"imageDescription\":\"props\",\"col\":\"props\"}"
import script from "./TwoBlocksLayout.vue?vue&type=script&lang=js"
export * from "./TwoBlocksLayout.vue?vue&type=script&lang=js"
script.render = render

export default script